import React, { Component } from 'react';
import '../App.css';
import Img from '../Img/vImg.png';

class FinishedScreen extends Component {
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return( 
        <div>
            <header>
                <div className="row-main">
                    <div className="col-4">
                    <div className="sponser-logo">
                        <label className="sponser-logo">כרמל 6000</label><br/>
                        <label className="sponser-logo">בחסות רשת אמית</label>
                    </div>
                    </div>
                    <div className="col-4 flex-bottom">
                        <h1>לוח 6000</h1>
                    </div>
                    <div className="col-4">
                        
                    </div>
                </div>
            </header>
            <div>
                <h4 className="desc-login h4-margin">האירוע/ים התווספו בהצלחה!</h4>
                <img src={Img} alt="calendar image" className="big-img"></img>
                <div className="margin-top-10">
                    <button className="btn addbtn" onClick={() => {this.props.updateFinished(false)}}>הוספת אירוע חדש</button>
                </div>
            </div>
            
        </div>
        );
    }
}
export default FinishedScreen;



// WEBPACK FOOTER //
// ./src/components/FinishedScreen.js